import {
  Calculator,
  CalendarRange,
  CheckCircle2,
  ClipboardList,
  CreditCard,
  FileText,
  Send,
  Users,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import Reveal from "@/components/landing/Reveal";

export default function Benefits() {
  const { t } = useTranslation();
  const benefits = [
    {
      icon: ClipboardList,
      title: t("landing.benefits.items.tickets.title"),
      desc: t("landing.benefits.items.tickets.desc"),
    },
    {
      icon: Calculator,
      title: t("landing.benefits.items.calculator.title"),
      desc: t("landing.benefits.items.calculator.desc"),
    },
    {
      icon: Send,
      title: t("landing.benefits.items.send.title"),
      desc: t("landing.benefits.items.send.desc"),
    },
    {
      icon: CheckCircle2,
      title: t("landing.benefits.items.approve.title"),
      desc: t("landing.benefits.items.approve.desc"),
    },
    {
      icon: CalendarRange,
      title: t("landing.benefits.items.scheduling.title"),
      desc: t("landing.benefits.items.scheduling.desc"),
    },
    {
      icon: CreditCard,
      title: t("landing.benefits.items.payments.title"),
      desc: t("landing.benefits.items.payments.desc"),
    },
    {
      icon: FileText,
      title: t("landing.benefits.items.invoices.title"),
      desc: t("landing.benefits.items.invoices.desc"),
    },
    {
      icon: Users,
      title: t("landing.benefits.items.team.title"),
      desc: t("landing.benefits.items.team.desc"),
    },
  ];

  return (
    <section id="features" className="border-y border-border/40 bg-muted/35 py-20 lg:py-28">
      <div className="container mx-auto px-4 lg:px-8">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold text-[#0C1F4F] md:text-4xl">
              {t("landing.benefits.title")}
            </h2>
            <p className="mt-4 text-lg text-muted-foreground">
              {t("landing.benefits.subtitle")}
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((benefit, index) => (
            <Reveal key={benefit.title} delayMs={index * 90}>
              <div className="group min-h-[220px] rounded-xl border border-border bg-card p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
                <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-accent/20">
                  <benefit.icon className="h-5 w-5 text-[#0C1F4F]" />
                </div>
                <h3 className="text-lg font-semibold text-[#0C1F4F]">{benefit.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{benefit.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
